import { IcmsBaseCalculationDeterminationMode } from '@/core/domain/invoice/invoiceNoteItems/invoiceNoteItemsParts/InvoiceNoteItems.types';
import { Select, SelectProps } from 'antd';

const options = [
  {
    value: IcmsBaseCalculationDeterminationMode.MARGIN_VALUE_ADDED,
    label: '0 - Margem Valor Agregado (%)',
  },
  {
    value: IcmsBaseCalculationDeterminationMode.TABLE_PRICE_MAX,
    label: '1 - Pauta (valor)',
  },
  {
    value: IcmsBaseCalculationDeterminationMode.LIST_PRICE_MAX,
    label: '2 - Preço Tabelado Máx. (valor)',
  },
  {
    value: IcmsBaseCalculationDeterminationMode.OPERATION_VALUE,
    label: '3 - Valor da operação',
  },
];

const TaxIcmsBcModalitySelect: React.FC<SelectProps> = (props) => {
  return <Select {...props} options={options} />;
};

export default TaxIcmsBcModalitySelect;
